import {getRequest, postRequest} from "../../../common/helpers/RequestHelper"

class PaymentService{
    apiLocation = "api/v1/pos/ecommerce/order/save_order"
    apiGenerateQr = "api/v1/payment/pos/generateQr"
    apiPaymentSmartPos = "api/v1/payment/create_payment/"
    apiPaymentCancelSmartPos = "api/v1/payment/cancel_payment/"
    apiMposManualCallback = "api/v1/m-pos/manual/callback"
    public fetchSaveOrderPosEcommerce(params:any): Promise<any>{
        return postRequest(this.apiLocation,params);
    }
    public fetchGenerateQr(params:any): Promise<any>{
        return getRequest(this.apiGenerateQr,params);
    }
    public fetchCreateNewPaymentPos(params:any,type:string): Promise<any>{
        return postRequest(`${this.apiPaymentSmartPos}${type}`,params);
    }
    public fetchCancelPaymentPos(params:any,type:string): Promise<any>{
        return postRequest(`${this.apiPaymentCancelSmartPos}${type}`,params);
    }
    public fetchMposManualCallback(params:any): Promise<any>{
        return postRequest(`${this.apiMposManualCallback}`,params);
    }
}

export const paymentService = new PaymentService();